import { OPENNED } from '@/configuration/signatureElectronique/signatureElectroniqueConf';

export default function genererCritereRecherche() {
  return {
    auto: null,
    contratEtatsSignature: [OPENNED],
    referencesSignature: [],
    societeId: null,
    commercialId: null,
    assistantId: null,
    referenceCode: null,
  };
}
